import { Step } from '../types';

import { isVariableStep } from 'pages/AutomationEngine/steps';

const orderSteps = (a: Step, b: Step) => (a.order || 0) - (b.order || 0);

export const splitAndPrepStepsAndVariables = (apiStepsAndVariables: Step[]) => {
  const stepsAndVariables = apiStepsAndVariables.sort(orderSteps);

  let steps = stepsAndVariables
    .filter((f) => !isVariableStep(f))
    .map((s, order) => ({ ...s, order }));

  const variables = stepsAndVariables.filter(isVariableStep);

  if (steps.length && variables.length) {
    const variableIds = variables.map((v) => v.id);

    steps = steps.map((step) => {
      return {
        ...step,
        parentStepId: variableIds.includes(step.parentStepId!)
          ? null
          : step.parentStepId,
      };
    });
  }

  return [steps, variables];
};

export const insertVariable = (variables: Step[], step: Step) => {
  const addNew = variables.pop();
  variables.push(step);
  variables.push(addNew!);

  let parentStepId: string | null = null;
  const orderVars = variables.map((v, order) => {
    const ret = { ...v, order, parentStepId };
    parentStepId = v.id;
    return ret;
  });

  return orderVars;
};
